<template>
  <section>
    <div class="card d-none d-md-block">
      <div class="card-body">
        <h3>{{ $t('message.professional.about_your_cleaner') }}</h3>
        <table class="table" style="margin-bottom: 0;">
          <tr>
            <td width="75">
              <router-link tag="a" :to="'/cleaner/'+id">
                <div class="avatar-container small">
                  <div :class="['dot', (professional.active === 1) ? 'active' : 'inactive']"></div>
                  <img v-lazy="professional.picture" class="rounded-circle message-user-img">
                </div>
              </router-link>
            </td>
            <td>
              <router-link tag="a" :to="'/cleaner/'+id">
                <label>{{ professional.name | firstName }}</label>
              </router-link>
              <br>{{ globalState.cities[professional.province_id] | multiLangName }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import i18n from '../../helpers/i18nHelpers'

  export default {
    props: ['id'],
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        professional: 'professional/getProfessional'
      })
    },
    mounted () {
      const queryData = {
        professional_id: this.id,
        language: i18n.locale
      }
      this.$store.dispatch('professional/LOAD_PROFESSIONAL_DETAIL', queryData)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/message/CleanerDetail.vue